module.exports = __webpack_public_path__ + "fonts/Lato-Bold.85d339d9.ttf";